import React, { Component } from "react";
//estilos de material design
import AppBar from "@material-ui/core/AppBar";
import BarSession from "./bar/BarSession";
import { withStyles } from "@material-ui/styles";
import { compose } from "recompose";
//accedemos a el consumer del objeto firebase en este componente
import { consumerFirebase } from "../../server";
//para poder extraer el valor del dispatch necesitamos importar el StateContext del archivo session/store.js
import { StateContext } from "../../session/store";

const styles = theme => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  }
});

class appNavbar extends Component {
  //extraemos los valores del context provider incluidos en la variable SessionContext para poder  usar sus variables globales en el buttonRegister, y en particualr poder usar el dispatch
  static contextType = StateContext;

  //estado inicial
  state = {
    firebase: null
  };

  //cuando la barra de navegacion haya sido montada y el objeto firebase listo
  //despues de esto los datos del usuario estan dentro del context provider del estado global de la aplicacion
  componentDidMount() {
    //llamamos al estado del objeto firebase y a los objetos del contexto necesarios para llamar a la bbdd
    const { firebase } = this.state;
    const [{ sesion }, dispatch] = this.context;
    //entonces si el usuario actual es diferente de null y la sesion no ha sido iniciada realizamos las siguientes operaciones
    if (firebase.auth.currentUser !== null && !sesion) {
      firebase.db
        .collection("Users")
        .doc(firebase.auth.currentUser.uid)
        .get()
        .then(doc => {
          const userDB = doc.data();
          //console.log(userDB);
          //el dispatch llama al reducer correspondiente para modificar el context global de la aplicacion
          dispatch({
            type: "START_SESSION",
            sesion: userDB,
            signin: true
          });
        });
    }
  }

  //cambia el objeto firebase si este es direrente al estado previo
  static getDerivedStateFromProps(nextProps, prevState) {
    let newObjects = {};
    if (nextProps.firebase !== prevState.firebase) {
      newObjects.firebase = nextProps.firebase;
    }
    return newObjects;
  }

  render() {
    //extraemos de nuevo el sesion y el dispatch del contexto global de la aplicacion
    const [{ sesion }, dispatch] = this.context;
    //creamos la condicion en funcion de la existenacia o no del sesion
    //y de la variable si esta o no autenticado en una doble condicion
    return sesion ? (
      sesion.signin ? (
        <div>
          <AppBar position="static">
            <BarSession />
          </AppBar>
        </div>
      ) : null
    ) : null;
  }
}

export default compose(withStyles(styles), consumerFirebase)(appNavbar);
